import React, { Component } from "react";
import axios from "axios";

class WarrantModalDelete extends Component {
    constructor(props) {
        super(props);
        this.state = {
            confirmationInput: ""
        };
        this.closeModal = this.closeModal.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.deleteRecord = this.deleteRecord.bind(this);
    }
    closeModal() {
        this.props.closeModal();
    }
    handleInputChange(event) {
        this.setState({ confirmationInput: event.target.value });
    }
    deleteRecord() {
        const toPost = { "PartitionKey": this.props.recordInfo.PartitionKey._, "RowKey": this.props.recordInfo.RowKey._ }
        axios.post("/removeNumber", toPost).then(() => {
            this.props.closeModalAndRefresh();
        });
    }
    render() {
        return (
            <div className="warrantModalDelete">
                <div className="warrantModalDelete__container">
                    <div className="warrantModalDelete__header">
                        <div>Deleting {this.props.recordInfo.warrantNo._}</div>
                        <div className="warrantModalDelete__headerExit"
                            onClick={this.closeModal}>
                                &times;
                        </div>
                    </div>
                    <div className="warrantModalDelete__body">
                        <div className="warrantModalDelete__bodyText">
                            <h5 className="warrantModalDelete__bodyText--header">Warning!</h5>
                            <p>
                                Deleting {this.props.recordInfo.warrantNo._} is irreversible. The action you're about to 
                            take can't be undone. Confirm you would like to proceed by typing the search 
                            warrant number you would like deleted.
                            </p>
                        </div>
                        <div className="warrantModalDelete__bodyInput">
                            <input 
                                type="text" 
                                className="warrantNoList__bodyInputElem" 
                                placeholder="Enter warrant number to delete" 
                                value={this.state.confirmationInput} 
                                onChange={this.handleInputChange}
                            />
                        </div>
                        <div className="warrantModalDelete__bodyButtons">
                            <button 
                                type="button" 
                                className={this.props.recordInfo.warrantNo._ === this.state.confirmationInput ? "warrantModalDelete__bodyButton warrantModalDelete__bodyButton--delete" : "warrantModalDelete__bodyButton"}
                                disabled={this.props.recordInfo.warrantNo._ === this.state.confirmationInput ? false : true}
                                onClick={this.deleteRecord}>
                                    Delete
                            </button>
                            <button 
                                type="button" 
                                className="warrantModalDelete__bodyButton"
                                onClick={this.closeModal}>
                                    Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default WarrantModalDelete;